<template>
  <span
    class="inline-flex items-center justify-center gap-1.5 rounded-full border text-xs font-medium px-2.5 py-0.5"
    :class="stateMeta.color"
    v-bind="$attrs"
  >
    <i :class="stateMeta.icon" class="text-[10px]"></i>
    {{ stateMeta.label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { PayoutBankAccountAssignmentState } from '@/types/shopifyPayouts'

interface StateMeta {
  label: string
  icon: string
  color: string
}

const STATE_CONFIG: Record<PayoutBankAccountAssignmentState, StateMeta> = {
  PENDING_ASSIGNMENT: {
    label: 'Pending',
    icon: 'pi pi-clock',
    color:
      'bg-yellow-50 text-yellow-700 border-yellow-200 dark:bg-yellow-900/20 dark:text-yellow-200 dark:border-yellow-700',
  },
  ASSIGNED: {
    label: 'Assigned',
    icon: 'pi pi-check-circle',
    color:
      'bg-green-50 text-green-700 border-green-200 dark:bg-green-900/20 dark:text-green-200 dark:border-green-700',
  },
  NO_BANK_ACCOUNT: {
    label: 'No Bank Account',
    icon: 'pi pi-info-circle',
    color:
      'bg-surface-50 text-surface-700 border-surface-200 dark:bg-surface-800 dark:text-surface-200 dark:border-surface-700',
  },
}

const props = defineProps<{
  state: PayoutBankAccountAssignmentState
}>()

const stateMeta = computed(
  () => STATE_CONFIG[props.state] || STATE_CONFIG.NO_BANK_ACCOUNT,
)
</script>
